import { useContext } from 'react';
import PermissionContext from '../userPermissionContext';

const useUserPermissionsContext = () => {
  return useContext(PermissionContext);
};

export default useUserPermissionsContext;
